import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { IMultiplyModel } from '@src/slide/domain/ui-model/element-modeles/Interface/multiply-model.interface';
import { getQuickSettingRectByModel } from './factory';
import { IQuickSettingRect } from './model/base';
import { IEmptyModel } from '@src/slide/domain/ui-model/element-modeles/Interface/empty-model.interface';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';

/**
 * 获取uiModel对应的悬浮工具栏的位置
 * @param model
 */
export function getQuickSettingRect(
    model: IElementBaseModel | IMultiplyModel | IEmptyModel,
    scale: number,
    isEditorTextExpanded: boolean,
): IQuickSettingRect | undefined {
    if (model.type === UIModelType.EMPTY) return;
    return getQuickSettingRectByModel(model as IElementBaseModel | IMultiplyModel)
        .getQuickSettingRect(scale, isEditorTextExpanded);
}
